<template>
  <div class="main-layout">
    <SidebarComponent ref="sidebarComponent" />
    <div class="main-content bg_color p-10">
      <router-view :key="$route.fullPath" />
    </div>
    <loader-item></loader-item>
  </div>
</template>
<script>
import LoaderItem from '@/components/loader/loader-item.vue'
import SidebarComponent from '@/components/SidebarComponent.vue'

export default {
  name: 'MainLayout',
  components: {
    LoaderItem,
    SidebarComponent
  },
  data () {
    return {
      containerCollapsed: 'toggled',
      tabledata: [],
      user: JSON.parse(localStorage.getItem('user'))
    }
  },
  created () {
  },
  methods: {
    showMenu () {
      this.$root.showMenuDrawerStatus = true
    },
    logout () {
      localStorage.clear()
      this.$router.push({
        path: '/login'
      })
    }
  }
}

</script>
<style scoped>
.main-layout {
  position: relative;
  min-height: 100vh;
  display: flex;
}

.main-content {
  flex: 1;
  margin-left: 280px;
  transition: margin-left 0.3s ease;
  min-height: 100vh;
}

.el-header {
  background-color: #ffffff;
  color: #333;
  line-height: 60px;
  padding: 0px;
  min-height: 68px;
}

.el-aside {
  color: #333;
}

.item {
  margin-top: 12px;
  margin-right: 20px;
}

.bg_color {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
}

.p-10 {
  padding: 24px;
}

/* Responsive */
@media (max-width: 1023px) {
  .main-content {
    margin-left: 0;
    width: 100%;
  }

  .p-10 {
    padding: 16px 12px;
  }
}

@media (max-width: 768px) {
  .p-10 {
    padding: 12px 8px;
  }
}

@media (max-width: 480px) {
  .p-10 {
    padding: 8px 4px;
  }
}
</style>
